import { isString } from 'lodash';
import moment from 'moment';

const DATE_TIME_FORMAT = 'L LTS';

const formatDateTime = (date, format = DATE_TIME_FORMAT) => {
  if (!date) {
    return '';
  }

  if (isString(date)) {
    return moment.parseZone(date).local().format(format);
  }

  return moment(date).format(format);
};

export default formatDateTime;
